import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
} from 'reactstrap';
import Icon from '../../atoms/Icon/Icon';
import './DeleteModal.scss';

const DeleteModal = ({
  isShown,
  onClose,
  onDelete,
  isLoading,
  children,
  isAllowed,
}) => (
  <Modal isOpen={isShown} toggle={onClose} className="delete-modal">
    <ModalBody>
      <div className="d-flex flex-column align-items-center justify-content-center">
        <div className="mb-5">
          {isAllowed ? (
            <img className="delete-modal-icon" src="/images/trash.svg" alt="Warning icon" />
          ) : (
            <img className="delete-modal-icon" src="/images/warning.svg" alt="Warning icon" />
          )}
        </div>
        <div className="w-50 text-center">
          {isAllowed ? (
            children
          ) : (
            <span>
              This instance is in use.
              Please remove it&apos;s relationships first before attempting deletion.
            </span>
          )}
        </div>
      </div>
    </ModalBody>
    <ModalFooter>
      <Button color="dark" onClick={onClose}>
        <Icon icon="times" color="#fff" />
        <span className="ms-2">Cancel</span>
      </Button>
      <Button color="danger" onClick={onDelete} disabled={!isAllowed}>
        {isLoading ? (
          <>
            <Spinner size="sm">
              Loading...
            </Spinner>
            <span>
              {' '}
              Loading
            </span>
          </>
        ) : (
          <>
            <Icon icon="trash" color="#fff" />
            <span className="ms-2">Delete</span>
          </>
        )}
      </Button>
    </ModalFooter>
  </Modal>
);

DeleteModal.propTypes = {
  isShown: PropTypes.bool,
  onClose: PropTypes.func,
  onDelete: PropTypes.func,
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  isAllowed: PropTypes.bool,
};

DeleteModal.defaultProps = {
  isShown: false,
  onClose: undefined,
  onDelete: undefined,
  isLoading: false,
  children: undefined,
  isAllowed: false,
};

export default DeleteModal;
